import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Dropdown } from 'primereact/dropdown';
import Layout from '../../../component/layout';
import DashboardTab from './tabs/dashboardTab';
import SmartPowerMetersTab from './tabs/smartPowerMetersTab';
import AnalogPowerMetersTab from './tabs/analogPowerMetersTab';
import CustomersTab from './tabs/customersTab';
import TransactionsTab from './tabs/transactionsTab';
import InvoicesTab from './tabs/invoicesTab';
import SettingsTab from './tabs/settingsTab';
import ChargesTab from './tabs/chargesTab';

const PowerMeterManagement = () => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    // Get active tab from URL params or default to 'dashboard'
    const [activeTab, setActiveTab] = useState(() => {
        return searchParams.get('tab') || 'dashboard';
    });

    const meterTypes = [
        { label: 'Power Meters', value: 'power', path: '/facility/utility_management/meter_management/power_meters' },
        { label: 'Water Meters', value: 'water', path: '/facility/utility_management/meter_management/water_meters' }
    ];

    const tabComponents = {
        dashboard: DashboardTab,
        'smart-power-meters': SmartPowerMetersTab,
        'analog-power-meters': AnalogPowerMetersTab,
        customers: CustomersTab,
        transactions: TransactionsTab,
        invoices: InvoicesTab,
        charges: ChargesTab,
        settings: SettingsTab
    };

    // Update URL when tab changes
    const handleTabChange = (tabName) => {
        setActiveTab(tabName);
        setSearchParams({ tab: tabName });
    };

    // Update state if URL changes (browser back/forward)
    useEffect(() => {
        const urlTab = searchParams.get('tab');
        if (urlTab && urlTab !== activeTab) {
            setActiveTab(urlTab);
        }
    }, [searchParams, activeTab]);

    const TabComponent = tabComponents[activeTab];

    return (
        <Layout>
            <div className="page-header">
                <div className="page-block">
                    <div className="row align-items-center">
                        <div className="col-md-12">
                            <ul className="breadcrumb mb-3">
                                <li className="breadcrumb-item">
                                    <Link to="/facility">Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to="/facility/utility_management/meter_types">Meters Management</Link>
                                </li>
                                <li className="breadcrumb-item active">
                                    <span>Power Meters</span>
                                </li>
                            </ul>
                            <div className="card">
                                <div className="card-header">
                                    <Link to="/facility/utility_management/meter_types" >
                                        <i className="ti ti-arrow-narrow-left"></i> Back
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <div className="card">
                        <div className="card-body py-0">
                            <ul className="nav nav-tabs profile-tabs" id="myTab" role="tablist">
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === 'dashboard' ? 'active' : ''}`}
                                        onClick={() => handleTabChange('dashboard')}
                                        type="button"
                                    >
                                        <i className="ti ti-dashboard me-2"></i>Dashboard
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === 'smart-power-meters' ? 'active' : ''}`}
                                        onClick={() => handleTabChange('smart-power-meters')}
                                        type="button"
                                    >
                                        <i className="ti ti-bolt me-2"></i>Smart Power Meters
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === 'analog-power-meters' ? 'active' : ''}`}
                                        onClick={() => handleTabChange('analog-power-meters')}
                                        type="button"
                                    >
                                        <i className="ti ti-bolt me-2"></i>Analog Power Meters
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === 'customers' ? 'active' : ''}`}
                                        onClick={() => handleTabChange('customers')}
                                        type="button"
                                    >
                                        <i className="ti ti-users me-2"></i>Customers
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === 'transactions' ? 'active' : ''}`}
                                        onClick={() => handleTabChange('transactions')}
                                        type="button"
                                    >
                                        <i className="ti ti-cash me-2"></i>Transactions
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === 'invoices' ? 'active' : ''}`}
                                        onClick={() => handleTabChange('invoices')}
                                        type="button"
                                    >
                                        <i className="ti ti-file-invoice me-2"></i>Invoices
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === 'charges' ? 'active' : ''}`}
                                        onClick={() => handleTabChange('charges')}
                                        type="button"
                                    >
                                        <i className="ti ti-cash me-2"></i>Charges
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === 'settings' ? 'active' : ''}`}
                                        onClick={() => handleTabChange('settings')}
                                        type="button"
                                    >
                                        <i className="ti ti-settings me-2"></i>Settings
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="tab-content">
                        <TabComponent />
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default PowerMeterManagement;